import React from 'react';
import PropTypes from "prop-types";
import { Form } from "reactstrap";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import EndpointFormFields from "./EndpointFormFields";
import Loader from "../../../common/Loader";
import FormFooter from "../../../common/forms/FormFooter";

export const EndpointForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <EndpointFormFields
        initialValues={initialValues}
      />
      <FormFooter />
    </Form>
  );
};

EndpointForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
};

EndpointForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = (state) => ({
  loading: !state.SecurityUnit.Endpoint.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'EndpointForm',
})(EndpointForm);

export default connect(mapStateToProps)(formComponent);